/* eslint-disable @typescript-eslint/no-explicit-any */
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { BaseCheckbox } from 'app/components/common/BaseCheckbox'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { SectionBase } from 'app/components/common/SectionBase'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { notificationController } from 'app/controllers/notification-controller'
import { usePagination } from 'app/hook'
import { useGetTradeUnionMember } from 'app/react-query/hook/tradeUnionMember'
import { IResponseQueryList } from 'app/react-query/model/common'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { isEqual } from 'lodash'
import { useMemo, useState } from 'react'
import styled from 'styled-components'

interface IProps {
  dataSelected: ITradeUnionMember[]
  limit?: number
  onChangeTums: (tums: ITradeUnionMember[]) => void
}

export const ModalSelectTum = ({
  dataSelected,
  limit,
  onChangeTums,
}: IProps) => {
  const [search, setSearch] = useState<string>('')
  const { flattenDataList } = usePagination()

  const { data: listTums, isLoading } = useGetTradeUnionMember({})

  const onSelected = (record: ITradeUnionMember) => {
    const isSelected = dataSelected.some(item => item?.id === record?.id)

    if (isSelected) {
      onChangeTums(dataSelected.filter(item => item?.id !== record?.id))
    } else {
      if (limit && dataSelected?.length === limit) {
        notificationController.warning({
          message: `Đã đặt tới giới hạn chọn (${limit})`,
        })
        return
      }
      onChangeTums([...dataSelected, record])
    }
  }

  const dataTable = useMemo(() => {
    const tumData: IResponseQueryList<ITradeUnionMember[]> =
      flattenDataList(listTums)
    return tumData?.data?.filter(
      item =>
        item?.fullName?.toLowerCase().includes(search.toLowerCase()) ||
        item?.email?.toLowerCase().includes(search.toLowerCase()),
    )
  }, [search, listTums])

  return (
    <div
      style={{
        backgroundColor: convertedVariables.neutralBlack9Color,
        borderRadius: 12,
        padding: 16,
      }}
    >
      <SectionBase title="Danh sách đoàn viên" style={{ paddingBottom: 0 }}>
        <BaseSpace size={4}>
          <BaseFormItem label={'Tìm kiếm'}>
            <BaseInput
              value={search}
              onChange={e => setSearch(e?.target?.value)}
              placeholder="Tìm kiếm theo tên, email"
            />
          </BaseFormItem>

          <BaseRow gutter={16} align={'middle'} justify={'space-between'}>
            <BaseCol>
              <BaseText
                children={'Danh sách'}
                fontWeight="medium"
                fontSize="xs"
              />
            </BaseCol>

            {limit ? (
              <BaseCol>
                <BaseRow gutter={6} align={'middle'}>
                  <BaseCol>
                    <BaseText
                      children={`Đã chọn: `}
                      fontWeight="medium"
                      opacity="0.7"
                    />
                  </BaseCol>
                  <BaseCol>
                    <BaseText
                      children={`${dataSelected?.length}/${limit}`}
                      fontWeight="semibold"
                      colorText={
                        isEqual(dataSelected?.length, limit)
                          ? 'statesGreenColor'
                          : 'statesOrangeColor'
                      }
                    />
                  </BaseCol>
                </BaseRow>
              </BaseCol>
            ) : null}
          </BaseRow>
          <BaseTableManagement
            columns={[
              convertColumnTable<ITradeUnionMember>({
                key: 'fullName',
                title: 'Họ và tên',
                render: (text: string, record) => {
                  return (
                    <BaseText
                      children={`${text} ${
                        record?.is_active ? '' : '(Dừng công tác)'
                      }`}
                      fontWeight="medium"
                      colorText={
                        record?.is_active ? 'primaryColor' : 'statesRedColor'
                      }
                    />
                  )
                },
              }),
              convertColumnTable<ITradeUnionMember>({
                key: 'email',
                title: 'Email',
                render: (text: string, record) => {
                  return (
                    <BaseText
                      children={text}
                      fontWeight="medium"
                      colorText={
                        record?.is_active ? 'primaryColor' : 'statesRedColor'
                      }
                    />
                  )
                },
              }),
              {
                key: 'id',
                title: '',
                width: '10%',

                dataIndex: 'id',
                render: (_, record: ITradeUnionMember) => {
                  const isSelected = dataSelected.some(
                    item => item?.id === record?.id,
                  )
                  return (
                    <BaseCheckbox
                      value={isSelected}
                      checked={isSelected}
                      onClick={() => onSelected(record)}
                      disabled={!record?.is_active}
                    />
                  )
                },
              },
            ]}
            dataSource={dataTable}
            className="row-overwrite-style"
            scroll={{ x: true }}
            loading={isLoading}
            pagination={{
              pageSize: 5,
            }}
          />
        </BaseSpace>
      </SectionBase>
    </div>
  )
}

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px;
`
